import React from "react";

class NordOverlay extends React.Component {

	constructor(props){
		super(props);
		this.state = {
			show: true
		}
	}

	closeOverlay = (e) => {
		e.preventDefault()
		this.setState({show: false})
	}

	linkClick = (e) => {
		e.stopPropagation()
		this.setState({show: false})
	}

    render() {
    	if(this.props.name === undefined) throw "missing NordOverlay prop 'name'"
    	if(this.state.show) {
	    	return(
					<div id="overlay-bg" className="nord-overlay-bg" onClick={this.closeOverlay}>
						<a id="nvc-overlay-nord" className={`nord-overlay d-block pointer`} target="_blank" href={`https://go.nordvpn.net/aff_c?offer_id=30&aff_id=30518&url_id=323&aff_sub=${this.props.name}`} onClick={this.linkClick}>
							<div id="overlay-close" className={`nord-overlay-close pointer`} onClick={this.closeOverlay}>
							X
							</div>
						</a>
					</div>
	    	)
    	}
    	else {
    		return(<></>)
    	}
    }
}

export default NordOverlay;
